import { render } from "./PatientResultFilePrintPreview.vue?vue&type=template&id=1f2d243d&scoped=true"
import script from "./PatientResultFilePrintPreview.vue?vue&type=script&lang=js"
export * from "./PatientResultFilePrintPreview.vue?vue&type=script&lang=js"

import "./PatientResultFilePrintPreview.vue?vue&type=style&index=0&id=1f2d243d&lang=scss&scoped=true"
import "./PatientResultFilePrintPreview.vue?vue&type=style&index=1&id=1f2d243d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f2d243d"]])

export default __exports__